import { render, staticRenderFns } from "./YearTable.vue?vue&type=template&id=588035e5&scoped=true"
import script from "./YearTable.vue?vue&type=script&lang=js"
export * from "./YearTable.vue?vue&type=script&lang=js"
import style0 from "./YearTable.vue?vue&type=style&index=0&id=588035e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588035e5",
  null
  
)

export default component.exports